import React from "react";
import Modal from "../UIElements/Modal";
import { Icon } from "../UIElements/Icon";
import { Button } from "../UIElements/Button";
import { useTranslation } from "react-i18next";

const FranchiseChangeConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  currentFranchiseName,
  newFranchiseName,
  isLoading = false,
}) => {
  const { t } = useTranslation("aiAgents");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t("franchiseChange.title")}
      subtitle={
        <>
          {t("franchiseChange.subtitle.prefix")}{" "}
          <span className="italic">{t("franchiseChange.subtitle.field")}</span>{" "}
          {t("franchiseChange.subtitle.suffix")}
        </>
      }
      maxWidth="max-w-2xl"
    >
      <div className="space-y-4">
        {/* Franchise Change Summary */}
        <div className="border-border bg-card rounded-md border p-4">
          <div className="flex items-center justify-between text-sm">
            <div>
              <span className="text-muted-foreground">
                {t("franchiseChange.summary.current")}
              </span>
              <span className="text-foreground ml-2 font-medium">
                {currentFranchiseName}
              </span>
            </div>
            <Icon
              name="ArrowRight"
              className="text-muted-foreground mx-2 h-4 w-4"
            />
            <div>
              <span className="text-muted-foreground">
                {t("franchiseChange.summary.new")}
              </span>
              <span className="text-foreground ml-2 font-medium">
                {newFranchiseName}
              </span>
            </div>
          </div>
        </div>

        {/* Warning Box */}
        <div className="border-warning rounded-md border bg-[var(--warning-bg)] p-4">
          <div className="flex gap-3">
            <Icon
              name="AlertTriangle"
              className="text-warning mt-0.5 h-5 w-5 flex-shrink-0"
            />
            <div className="flex-1">
              <h4 className="text-warning mb-2 font-medium">
                {t("franchiseChange.warning.title")}
              </h4>
              <ul className="text-foreground space-y-2 text-sm">
                <li className="flex items-start gap-2">
                  <span className="text-warning mt-0.5">•</span>
                  <span>{t("franchiseChange.warning.items.activeReset")}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-warning mt-0.5">•</span>
                  <span>
                    {t("franchiseChange.warning.items.closedUnaffected")}
                  </span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-warning mt-0.5">•</span>
                  <span>{t("franchiseChange.warning.items.stateLoss")}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3 pt-2">
          <Button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            variant="outline"
            className="flex-1 rounded-md px-4 py-2 text-sm font-medium"
          >
            {t("actions.cancel")}
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            variant="outline"
            className="flex-1 rounded-md border-[var(--warning)] bg-[var(--warning)] px-4 py-2 text-sm font-medium text-[var(--warning-foreground)] hover:bg-[var(--warning)] hover:opacity-90"
          >
            {isLoading
              ? t("actions.saving")
              : t("franchiseChange.actions.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default FranchiseChangeConfirmationModal;
